import { useState } from 'react';
import { AdminDashboardFilters } from '../../types';
import useUserStore from 'store/user.store';
import useAdminDashboardFiltersStore, {
  initialAdminDashboardFilters,
} from 'store/adminDashboardFilters.store';
import {
  usePartnerShortQuery,
  useRolesQuery,
  useTeamsShortQuery,
  useUserListShortQuery,
} from '@common/cache';

export const useAdminView = () => {
  const { user } = useUserStore();
  const { filters, setFilters, resetFilters } = useAdminDashboardFiltersStore();

  const canResetFilters =
    JSON.stringify(filters) !== JSON.stringify(initialAdminDashboardFilters);

  const [viewTabIndex, setViewTabIndex] = useState('1');
  const [entityTabIndex, setEntityTabIndex] = useState('1');

  const handleFilterChange = (newFilters: Partial<AdminDashboardFilters>) => {
    setFilters(newFilters);
  };

  const handleResetFilters = () => {
    resetFilters();
  };

  const { data: users } = useUserListShortQuery({});
  const { data: roles } = useRolesQuery();
  const { data: teams } = useTeamsShortQuery({});
  const { data: supervisorOptions = [] } = useUserListShortQuery({
    roles: ['organization_supervisor', 'partner_supervisor'],
  });
  const { data: partnerOptions = [] } = usePartnerShortQuery();

  const handleEntityTabChange = (
    event: React.SyntheticEvent,
    newIndex: string,
  ) => {
    setEntityTabIndex(newIndex);
  };

  const handleViewTabChange = (newIndex: string) => {
    setViewTabIndex(newIndex);
  };

  return {
    user,
    filters,
    handleFilterChange,
    viewTabIndex,
    handleViewTabChange,
    entityTabIndex,
    handleEntityTabChange,
    userList: users?.map(o => ({ value: o.id, label: o.name })),
    roleList: roles?.map(o => ({ value: o.role_name, label: o.display_name })),
    teamList: teams?.map(o => ({ value: o.id, label: o.name })),
    supervisorOptions: [
      ...(supervisorOptions?.map(o => ({
        value: o.id,
        label: o.name,
      })) ?? []),
      { value: 'null', label: 'No supervisor' },
    ],
    partnerOptions: partnerOptions?.map(o => ({
      value: o.id,
      label: o.name,
    })),
    handleResetFilters,
    canResetFilters,
  };
};
